export const orderAlertDefaultMessage =
  'Se creará una nueva solicitud de Devolución y el producto se marcará como <bold>Por revisar</bold>'
